<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaEquipmentVersionForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEquipmentVersionForm from '@/components/settings/arena/equipment-version/ArenaEquipmentVersionForm'

export default {
  name: 'ArenaEquipmentVersionAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaEquipmentVersionForm
  }
}
</script>
